const API_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwFDT0BL8njJETmvNV-Se80yScA7_i9aqZi9E-Bp_-g_dKFkW3MsRcCDGCRVvY7fGEz/exec';

export const fetchEvents = async () => {
  try {
    const response = await fetch(API_ENDPOINT);
    if (!response.ok) {
      throw new Error('Failed to fetch events');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching events:', error);
    // Fallback to static data if fetch fails
    return null;
  }
};

// Utility functions to filter events by status
export const getEventsByStatus = (events, status) => {
  if (!events) return {};
  const filteredEvents = {};

  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEventData = {
      ...eventData,
      events: eventData.events.filter(event => event.status === status)
    };

    if (filteredEventData.events.length > 0) {
      filteredEvents[eventType] = filteredEventData;
    }
  });

  return filteredEvents;
};

export const getUpcomingEvents = (events) => {
  if (!events) return {};
  const filteredEvents = {};

  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEventData = {
      ...eventData,
      events: eventData.events.filter(event =>
        event.status === 'upcoming' || event.status === 'happening-now' || event.status === 'displayOnly'
      )
    };

    if (filteredEventData.events.length > 0) {
      filteredEvents[eventType] = filteredEventData;
    }
  });

  return filteredEvents;
};

export const getPastEvents = (events) => getEventsByStatus(events, 'past');
export const getExpiredEvents = (events) => getEventsByStatus(events, 'expired');

// Events with status 'happening-now' are excluded from display by design
export const getDisplayableEvents = (events) => {
  if (!events) return {};
  const filteredEvents = {};

  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEventData = {
      ...eventData,
      events: eventData.events.filter(event => event.status !== 'happening-now')
    };

    if (filteredEventData.events.length > 0) {
      filteredEvents[eventType] = filteredEventData;
    }
  });

  return filteredEvents;
};

// Get starred events - filters events where stared is true (not "", false, or undefined)
export const getStaredEvents = (events) => {
  if (!events) return {};
  const staredEvents = {};

  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEventData = {
      ...eventData,
      events: eventData.events.filter(event => event.stared === true)
    };

    if (filteredEventData.events.length > 0) {
      staredEvents[eventType] = filteredEventData;
    }
  });

  return staredEvents;
};

// Get all starred events as a flat array (useful for displaying in a single section)
export const getStaredEventsArray = (events) => {
  if (!events) return [];
  const staredEventsArray = [];

  Object.entries(events).forEach(([eventType, eventData]) => {
    const filteredEvents = eventData.events.filter(event => event.stared === true);
    staredEventsArray.push(...filteredEvents);
  });

  // Sort by ID in descending order (newest first)
  return staredEventsArray.sort((a, b) => b.id - a.id);
};